'use es6';

import * as ActionTypes from './ActionTypes';
import I18n from 'I18n';
const I18N_PREFIX = 'appMarketplace.detail.header.connectAppButton.error';
export const connectAppCancelled = () => ({
  type: ActionTypes.APP_CONNECTION_CANCELLED,
  meta: {
    notification: {
      type: 'danger',
      titleText: I18n.text(`${I18N_PREFIX}.cancelled.titleText`),
      message: I18n.text(`${I18N_PREFIX}.cancelled.message`)
    }
  }
});
export const connectAppAdminRequired = appName => ({
  type: ActionTypes.APP_CONNECTION_ADMIN_REQUIRED,
  meta: {
    notification: {
      type: 'danger',
      titleText: I18n.text(`${I18N_PREFIX}.adminRequired.titleText`),
      message: I18n.text(`${I18N_PREFIX}.adminRequired.message`, {
        appName
      })
    }
  }
});
export const connectAppInvalidLicense = appName => ({
  type: ActionTypes.APP_CONNECTION_INVALID_LICENSE,
  meta: {
    notification: {
      type: 'danger',
      titleText: I18n.text(`${I18N_PREFIX}.invalidLicense.titleText`),
      message: I18n.text(`${I18N_PREFIX}.invalidLicense.message`, {
        appName
      })
    }
  }
});
export const connectAppPermissionsRequired = () => ({
  type: ActionTypes.APP_CONNECTION_PERMISSIONS_REQUIRED,
  meta: {
    notification: {
      type: 'danger',
      titleText: I18n.text(`${I18N_PREFIX}.permissionsRequired.titleText`),
      message: I18n.text(`${I18N_PREFIX}.permissionsRequired.message`)
    }
  }
});
export const connectAppThirdPartyUnavailable = appName => ({
  type: ActionTypes.APP_CONNECTION_THIRD_PARTY_UNAVAILABLE,
  meta: {
    notification: {
      type: 'danger',
      titleText: I18n.text(`${I18N_PREFIX}.thirdPartyUnavailable.titleText`, {
        appName
      }),
      message: I18n.text(`${I18N_PREFIX}.thirdPartyUnavailable.message`, {
        appName
      })
    }
  }
});
export const connectAppGenericFailure = () => ({
  type: ActionTypes.APP_CONNECTION_GENERIC_FAILED,
  meta: {
    notification: {
      type: 'danger',
      titleText: I18n.text(`${I18N_PREFIX}.default.titleText`),
      message: I18n.text(`${I18N_PREFIX}.default.message`)
    }
  }
});
export const handleConnectError = (errorType, appName) => dispatch => {
  switch (errorType) {
    case 'CANCELLED':
      dispatch(connectAppCancelled());
      break;

    case 'INTEGRATION_ADMIN_REQUIRED':
      dispatch(connectAppAdminRequired(appName));
      break;

    case 'INTEGRATION_INVALID_LICENSE':
      dispatch(connectAppInvalidLicense(appName));
      break;

    case 'INTEGRATION_PERMISSIONS_REQUIRED':
      dispatch(connectAppPermissionsRequired());
      break;

    case 'INTEGRATION_THIRD_PARTY_UNAVAILABLE':
      dispatch(connectAppThirdPartyUnavailable(appName));
      break;

    default:
      dispatch(connectAppGenericFailure());
  }
};